module.exports = __webpack_public_path__ + "img/dianxin008-1.c2087213.png";